import { createContext, useContext } from 'react';
import { TiltPermissionGate, useTiltPermissionGate } from './useTiltPermissionGate';

export const TiltPermissionContext = createContext<TiltPermissionGate | null>(null);

/**
 * The gate from the nearest provider, falling back to one of the caller's own so the card still
 * works with no provider above it. Both hooks run, as hooks must, but the losing one never asks:
 * its effect waits on a `sectionRef` nothing attaches.
 */
export const useTiltPermissionForSection = (trackLocation: string): TiltPermissionGate => {
    const provided = useContext(TiltPermissionContext);
    const local = useTiltPermissionGate({ trackLocation });

    return provided ?? local;
};
